import { Routes } from '@angular/router';

export const WELCOME_ROUTES: Routes = [
	{
		path: 'welcome',
		loadComponent: () => import('./feature-welcome/welcome').then((m) => m.Welcome),
		data: { title: 'Visão Geral' },
	},
];
